// extracted by mini-css-extract-plugin
module.exports = {"container":"jg-z","heading":"kg-z","links":"lg-z","linkBtn":"mg-z","disabled":"ng-z","linkUppercaseBold":"og-z","copy":"pg-z","subCopy":"qg-z"};